<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-primary">
            <div class="row">
              <div class="col-8 d-flex align-items-center gap-3">
                <div>
                  <h4 class="card-title mt-0">Case List</h4>
                  <p class="card-category">Manage your cases</p>
                </div>
                <div class="flex-grow-1" style="max-width: 300px;">
                  <app-search [(value)]="searchTerm"
                              (valueChange)="onSearchChange()"
                              placeholder="Search">
                  </app-search>
                </div>
              </div>
              <div class="col-4 text-end">
                <button mat-raised-button type="button" class="btn btn-success pull-right" [routerLink]="['/cases/create']">Add New Case</button>
              </div>
            </div>
          </div>

          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-hover table-striped">
                <thead class=" text-primary">
                    <th>ID</th>
                    <th>Case</th>
                    <th>Filing Date</th>
                    <th>Status</th>
                    <th>Judge</th>
                    <th>Opposite Party Advocate</th>
                    <th>Actions</th>
                </thead>
                <tbody>
                  <tr *ngFor="let caseItem of cases">
                    <td>{{ caseItem.id }}</td>
                    <td>
                      {{ caseItem.caseType?.name || '-' }},
                      {{ caseItem.district?.name || '-' }},
                      {{ caseItem.courtType?.name || '-' }},
                      <span class="fw-bold">{{ caseItem.caseNumber || '-' }}/{{ caseItem.year || '-' }}</span>,
                      <span class="fw-bold">{{ caseItem.client?.fullName || '-' }} ({{ caseItem.partyRole || '-' }})</span>
                      V/S
                      {{ caseItem.oppositeParty || '-' }} ({{ caseItem.oppositePartyRole || '-' }})
                    </td>
                    <td>{{ caseItem.filingDate ? (caseItem.filingDate | date:'dd-MMM-yyyy') : '-' }}</td>
                    <td>
                      {{ caseItem.status || '-' }}
                      <ng-container *ngIf="caseItem.status === 'Disposed' || caseItem.status === 'Disposed (Dormant)'; let showDates">
                        <div *ngIf="caseItem.transferredAt">
                          (Transferred At: {{ caseItem.transferredAt | date:'dd-MMM-yyyy' }})
                        </div>
                        <div *ngIf="caseItem.disposedAt">
                          (Disposed At: {{ caseItem.disposedAt | date:'dd-MMM-yyyy' }})
                        </div>
                      </ng-container>
                    </td>
                    <td>{{ caseItem.judge || '-' }}</td>
                    <td>{{ caseItem.oppositePartyAdvocate || '-' }}</td>
                    <td>
                      <i class="material-icons text-danger" style="cursor: pointer;" (click)="deleteCase(caseItem.id)">delete</i>
                      <i class="material-icons text-warning" style="cursor: pointer;" [routerLink]="['/cases/edit', caseItem.id]">edit</i>
                      <i class="material-icons text-primary" style="cursor: pointer;" (click)="openAttachmentsModal(caseItem.attachments,caseItem)">folder</i>
                    </td>
                  </tr>
                </tbody>
              </table>

              <mat-paginator [length]="totalItems"
                             [pageSize]="pageSize"
                             [pageSizeOptions]="[5, 10, 25, 50]"
                             (page)="onPageChange($event)">
              </mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
